export default __webpack_public_path__ + "static/media/ri_twitter.25f20eb2.svg";